@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.screens_cus

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.example.project.engineservice.ServiceApi
import org.example.project.enginetabular.TabularScreen
import org.example.project.service.ZustandManager
import org.example.project.service.LoginService
import org.example.project.service.GlobalManager
import org.example.project.utils.All

@Composable
fun CUSCRAuskunft() {
    val crLiveVersion = GlobalManager.jsonDomainVersion("cr")
    var crs by remember { mutableStateOf<List<All>>(emptyList()) }
    var letzteFilter by remember { mutableStateOf<Map<String, String>?>(null) }
    val scope = rememberCoroutineScope()
    val uid = remember { LoginService.getId() }
    val firmenId = remember { LoginService.getUser()?.firmenId.orEmpty() }

    LaunchedEffect(uid, firmenId, crLiveVersion) {
        crs = letzteFilter?.let { filters ->
            runCatching { ServiceApi.searchCr("company", filters) }.getOrDefault(emptyList())
        }.orEmpty()
    }

    val headers = listOf(
        "CR ID",
        "FirmenId",
        "Firma",
        "CR Nummer",
        "CR Art",
        "Betreff",
        "Aufwand (geschaetzt)",
        "Aufwand (final)",
        "Zustand"
    )

    TabularScreen(
        screenKey = "CUSCRAuskunft",
        rollenKey = "CUSCRAuskunft",
        title = "CR Auskunft (Kunde)",
        headers = headers,
        data = crs.map { cr ->
            val artLabel = when {
                cr.crNeuesModul -> "Neues Modul"
                cr.crAenderungAktivModul.isNotBlank() -> "Änderung: ${cr.crAenderungAktivModul}"
                else -> "Änderung"
            }
            cr.id to listOf(
                cr.id,
                cr.firmenId.ifBlank { "-" },
                cr.kunde.ifBlank { cr.firma.ifBlank { "-" } },
                cr.crNummer.ifBlank { "#${cr.id}" },
                artLabel,
                cr.crBeschreibung.ifBlank { "-" },
                if (cr.crAufwandStunden > 0) "${cr.crAufwandStunden} Stunden" else "-",
                if (cr.crAufwandFinal > 0) "${cr.crAufwandFinal} Stunden" else "-",
                ZustandManager.CR.textFor(cr.zustand)
            )
        },
        editable = false,
        hardReadOnly = true,
        includeMetadata = true,
        nonEditableCols = headers.toSet(),
        allowCreate = false,
        allowDelete = false,
        onSearchWithFilters = { filters ->
            scope.launch {
                letzteFilter = filters
                crs = ServiceApi.searchCr("company", filters)
            }
        },
        dropdownOptions = emptyMap(),
        createRow = { _ -> List(headers.size) { "" } },
        onCommit = { _ -> },
        onDeleteRows = { _ -> },
        onRowClick = { _ -> }
    )
}
